import { render, staticRenderFns } from "./HomePageRecentlyViewed.vue?vue&type=template&id=10a3fcb8&scoped=true"
import script from "./HomePageRecentlyViewed.vue?vue&type=script&lang=js"
export * from "./HomePageRecentlyViewed.vue?vue&type=script&lang=js"
import style0 from "./HomePageRecentlyViewed.vue?vue&type=style&index=0&id=10a3fcb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3fcb8",
  null
  
)

export default component.exports